<template>
  <li class="course_list_item" @click="detail('school_detail',item.id,item.code)">
    <div class="item_t">
      <img :src="item.coverPath" alt />
      <div class="course_price"></div>
      <!-- <div class="course_duration">{{test(item.duration)}}</div> 课程总时间廖坑坑做不了-->
    </div>
    <div class="item_b">
      <div class="t">
        <div class="l">{{item.name}}</div>
        <div class="r">
          <i class="el-icon-view"></i>
          <span>{{item.popularity}}</span>
        </div>
      </div>
      <div class="b">主讲人：{{item.speaker}}</div>
    </div>
    <div class="item_f" v-if="configs && configs.progress">
      <div>学习进度{{item.co_play_schedule}}%</div>
      <div class="progress_box">
        <el-progress class="my_progress" :percentage="parseInt(item.co_play_schedule)" :show-text="false" :stroke-width="3"></el-progress>
      </div>
    </div>
  </li>
</template>

<script>
export default {
  props: {
    item: {
      type: Object
    },
    configs: {
      type: Object,
      default() {
        return {
          progress: false
        };
      }
    }
  },
  methods: {
    detail(name, id, code) {
      this.$router.push({
        name: name,
        query: {
          id: id,
          code: code
        }
      });
    },
    // 秒转换为时分秒
    test(s) {
      var hour = Math.floor(s / 3600);
      hour = hour < 10 ? "0" + hour : hour;
      var minute = Math.floor((s - hour * 3600) / 60);
      minute = minute < 10 ? "0" + minute : minute;
      var second = Math.floor(s - hour * 3600 - minute * 60);
      second = second < 10 ? "0" + second : second;
      var _html = hour>0?`${hour}时${minute}分${second}秒`:`${minute}分${second}秒`;
      return _html;
    }
  }
};
</script>

<style lang="scss" scoped>
.course_list_item {
  cursor: pointer;
  margin-right: 20px;
  width: 285px;
  display: flex;
  flex-direction: column;
  .item_t {
    position: relative;
    background: #f0f0f0;
    width: 285px;
    height: 160px;
    img {
      width: 285px;
      height: 160px;
      border-radius: 4px;
      object-fit: cover;
      object-position: center;
    }
    .collection {
      width: 34px;
      height: 34px;
      text-align: center;
      line-height: 34px;
      background: rgba(0, 0, 0, 0.3);
      border-radius: 50%;
      position: absolute;
      left: 10px;
      top: 10px;
      cursor: pointer;
      i {
        font-size: 16px;
        color: #fff;
      }
    }
    .course_duration {
      position: absolute;
      right: 10px;
      bottom: 10px;
      height: 18px;
      line-height: 18px;
      background: rgba(0, 0, 0, 0.2);
      border-radius: 9px;
      padding: 0 7px;
      font-size: 12px;
      color: rgba(255, 255, 255, 1);
    }
  }
  .item_b {
    padding: 8px 14px 14px;
    box-sizing: border-box;
    .t {
      display: flex;
      line-height: 28px;
      .l {
        width: 209px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        font-size: 14px;
        color: rgba(102, 102, 102, 1);
      }
      .r {
        flex: 1;
        font-size: 12px;
        color: rgba(153, 153, 153, 1);
        text-align: right;
        i {
          margin-right: 6px;
        }
      }
    }
    .b {
      line-height: 28px;
      font-size: 14px;
      color: rgba(159, 164, 177, 1);
    }
  }
  .item_f {
    display: flex;
    font-size: 14px;
    color: rgba(159, 164, 177, 1);
    padding: 14px;
    border-top: 1px solid #E5E8ED;
    .progress_box {
      flex: 1;
      margin-left: 13px;
      .my_progress {
        margin-top: 5px;
      }
    }
  }
}
// .course_list_item:nth-child(4n) {
//   margin-right: 0;
// }
</style>